import { render, staticRenderFns } from "./ChartPrpPorTipologia.vue?vue&type=template&id=e726622e&"
import script from "./ChartPrpPorTipologia.vue?vue&type=script&lang=js&"
export * from "./ChartPrpPorTipologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports